import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { getModuleGroupById } from '@softline/application';
import { provideMdeInventoryGlobals } from './inventory.globals';
import { SOFTLINE_PERMISSION_MDE_INVENTORY } from './inventory.permissions';
import { mdeInventoryRoutes } from './inventory.routes';
import { MdeInventoryModuleConfig } from './inventory.shared';

export function provideMdeInventoryModule(config?: MdeInventoryModuleConfig) {
  return [
    provideSoftAppsModule(
      {
        name: 'Inventur',
        title: 'Inventur',
        icon: 'fa-regular fa-shelves',
        route: '/mde-inventur',
        version: 'v1.5',
        permission: SOFTLINE_PERMISSION_MDE_INVENTORY,
        group: getModuleGroupById(6),
      },
      withSoftAppsModuleRoutes({ app: mdeInventoryRoutes }),
      withSoftAppsModuleInfo({
        library: '@softapps/mde/inventory',
        remoteConfig: 'mde-inventur',
        description: 'Inventur mit dem MDE-Gerät.',
      })
    ),
    ...provideMdeInventoryGlobals(config),
  ];
}
